"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _isEqual = _interopRequireDefault(require("date-fns/isEqual"));

var _reactDayPicker = _interopRequireDefault(require("react-day-picker"));

var _Card = _interopRequireDefault(require("../../elements/Card"));

var _Select = _interopRequireDefault(require("../../elements/Select"));

var _PresetOption = _interopRequireDefault(require("./PresetOption"));

var _DateTextInput = _interopRequireDefault(require("./DateTextInput"));

require("react-day-picker/lib/style.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function DateRangePickerCard(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      _onChange = props.onChange,
      selectOptions = props.selectOptions,
      selectedItem = props.selectedItem,
      onChangeSelectedItem = props.onChangeSelectedItem,
      presetRanges = props.presetRanges;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var _useState3 = (0, _react.useState)({
    from: startDate,
    to: endDate
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      localCalendarDateRange = _useState4[0],
      setLocalCalendarDateRange = _useState4[1];

  (0, _react.useEffect)(function () {
    var selectedPreset = _lodash.default.find(presetRanges, function (_ref) {
      var start = _ref.start,
          end = _ref.end;
      return (0, _isEqual.default)(startDate, start) && (0, _isEqual.default)(endDate, end);
    });

    setSelectedOption((selectedPreset === null || selectedPreset === void 0 ? void 0 : selectedPreset.label) || 'custom');
  }, [presetRanges, startDate, endDate, setSelectedOption]);
  (0, _react.useEffect)(function () {
    setLocalCalendarDateRange({
      from: startDate,
      to: endDate
    });
  }, [startDate, endDate, setLocalCalendarDateRange]);
  ;
  var isSelecting = !localCalendarDateRange.to;
  return _react.default.createElement(_Card.default, {
    className: "flex"
  }, _react.default.createElement("div", {
    className: "p-6 bg-gray-lighter",
    style: {
      minWidth: 180
    }
  }, selectOptions && _react.default.createElement("div", {
    className: "mb-4"
  }, _react.default.createElement(_Select.default, {
    className: "tracking-wide bg-white",
    size: "small",
    items: selectOptions,
    selectedItem: selectedItem,
    onChange: onChangeSelectedItem
  })), presetRanges.map(function (presetObj) {
    return _react.default.createElement(_PresetOption.default, {
      key: presetObj.label,
      className: "mb-1",
      isSelected: selectedOption === presetObj.label,
      label: presetObj.label,
      onClick: function onClick() {
        setSelectedOption(presetObj.label);

        _onChange(presetObj.start, presetObj.end);
      }
    });
  }), _react.default.createElement(_PresetOption.default, {
    isSelected: selectedOption === 'custom',
    label: "Custom Range",
    onClick: function onClick() {
      return setSelectedOption('custom');
    }
  })), _react.default.createElement("div", {
    className: "p-6"
  }, _react.default.createElement("div", {
    className: "flex items-center justify-between mb-4"
  }, _react.default.createElement(_DateTextInput.default, {
    date: startDate,
    onChange: function onChange(date) {
      return _onChange(date, endDate);
    }
  }), _react.default.createElement("div", {
    className: "mx-4"
  }, "to"), _react.default.createElement(_DateTextInput.default, {
    date: endDate,
    onChange: function onChange(date) {
      return _onChange(startDate, date);
    }
  })), _react.default.createElement(_reactDayPicker.default, {
    className: "InsightsDatePicker w-full",
    selectedDays: [localCalendarDateRange],
    disabledDays: isSelecting ? {
      before: localCalendarDateRange.from
    } : {},
    modifiers: {
      start: localCalendarDateRange.from,
      end: localCalendarDateRange.to
    },
    month: localCalendarDateRange.to || localCalendarDateRange.from,
    onDayClick: function onDayClick(date) {
      if (isSelecting) {
        setLocalCalendarDateRange({
          from: localCalendarDateRange.from,
          to: date
        });

        _onChange(localCalendarDateRange.from, date);
      } else {
        setLocalCalendarDateRange({
          from: date,
          to: undefined
        });
      }
    }
  })));
}

DateRangePickerCard.propTypes = {
  startDate: _propTypes.default.instanceOf(Date).isRequired,
  endDate: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func.isRequired,
  selectOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  selectedItem: _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  onChangeSelectedItem: _propTypes.default.func,
  presetRanges: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    start: _propTypes.default.instanceOf(Date),
    end: _propTypes.default.instanceOf(Date)
  })).isRequired
};
var _default = DateRangePickerCard;
exports.default = _default;